import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import {
	StyledSelect,
} from 'lib/styles';

import { defaultTextSlot } from '../../../../layoutConfig';

import {
	Container,
	Label,
} from './styles';

class ContentFromDb extends React.PureComponent {
	selectContent = type => {
	  const { t, lng: language, buildingContent, spaceContent } = this.props;
	  const contents = {
	    // Building
	    buildingIngress: buildingContent[language].ingress,
	    buildingDescription: buildingContent[language].description,
	    // Additional info
	    building_services_additional_info: `
				<h3>${t('controls/text/content/building_services_additional_info')}</h3>
				<p>${buildingContent[language].building_services_additional_info}</p>`,
	    building_service_parking_additional_info: `
				<h3>${t('controls/text/content/building_service_parking_additional_info')}</h3>
				<p>${buildingContent[language].building_service_parking_additional_info}</p>`,
	    local_services_additional_info: `
				<h3>${t('controls/text/content/local_services_additional_info')}</h3>
				<p>${buildingContent[language].local_services_additional_info}</p>`,
	    accessibility_additional_info: `
				<h3>${t('controls/text/content/accessibility_additional_info')}</h3>
				<p>${buildingContent[language].accessibility_additional_info}</p>`,
	    // Space
	    environment_certificate_text: `<p>${buildingContent[language].environment_certificate_text}</p>`,
	    spaceIngress: spaceContent && language in spaceContent ? spaceContent[language].ingress : '',
	    spaceDescription: spaceContent && language in spaceContent ? spaceContent[language].description : '',
	  };
	  const content = type in contents ? contents[type] : false;

	  if (content) {

	    const currentEditorState = this.props.editorState[language];

	    let currentMarkupValue = draftToHtml(convertToRaw(currentEditorState.getCurrentContent()));

	    if (currentMarkupValue.trim() === defaultTextSlot.data.value[language]) {
	      currentMarkupValue = '';
	    } else {
	      //currentMarkupValue += '</p>';
	    }

	    currentMarkupValue += content.indexOf('</') === -1 ? `<p>${content}</p>` : content;

	    const blocksFromHTML = htmlToDraft(currentMarkupValue);

	    const state = ContentState.createFromBlockArray(
	      blocksFromHTML.contentBlocks,
	      blocksFromHTML.entityMap
	    );
	    const editorState = EditorState.createWithContent(state);

	    this.props.updateEditorState(editorState);
	  }
	}

	render () {
	  const { t, lng, buildingContent, spaceContent } = this.props;

	  const options = [{
	    name: t('controls/text/content/choose'),
	    value: 'select',
	  }];
	  const buildingOptions = {
	    name: t('controls/text/content/building'),
	    options: []
	  };
	  const additionalInfoOptions = {
	    name: t('controls/text/content/additional_info'),
	    options: []
	  };
	  const spaceOptions = {
	    name: t('controls/text/content/space'),
	    options: [],
	  };

	  if (buildingContent[lng].ingress !== '') {
	    buildingOptions.options.push({
	      name: t('controls/text/content/ingress'),
	      value: 'buildingIngress',
	    })
	  }

	  if (buildingContent[lng].description !== '') {
	    buildingOptions.options.push({
	      name: t('controls/text/content/description'),
	      value: 'buildingDescription',
	    })
	  }

	  [
	    'building_services_additional_info',
	    'building_service_parking_additional_info',
	    'local_services_additional_info',
	    'accessibility_additional_info',
	    'environment_certificate_text',
	  ].forEach(key => {
	    if (buildingContent[lng][key] !== '') {
	      additionalInfoOptions.options.push({
	        name: t('controls/text/content/' + key),
	        value: key,
	      })
	    }
	  });

	  if (buildingOptions.options.length > 0) {
	    options.push(buildingOptions);
	  }

	  if (additionalInfoOptions.options.length > 0) {
	    options.push(additionalInfoOptions);
	  }

	  if (spaceContent) {
	    if (spaceContent[lng].ingress !== '') {
	      spaceOptions.options.push({
	        name: t('controls/text/content/ingress'),
	        value: 'spaceIngress',
	      })
	    }

	    if (spaceContent[lng].description !== '') {
	      spaceOptions.options.push({
	        name: t('controls/text/content/description'),
	        value: 'spaceDescription',
	      })
	    }

	    if (spaceOptions.options.length > 0) {
	      options.push(spaceOptions);
	    }
	  } else {
	    options.push({
	      name: t('controls/text/content/No space selected'),
	      options: []
	    });
	  }

	  return options.length === 1 ? null : (
	    <Container>
	      <Label>{t('controls/text/content/label')}</Label>
	      <StyledSelect
	        style={{
	          width: '100%',
	        }}
	        options={options}
	        id="content-from"
	        onChange={event => {
	          this.selectContent(event.target.value);
	          event.target.value = 'select';
	        }}
	      />
	    </Container>
	  )
	}
}

ContentFromDb.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	buildingContent: PropTypes.object,
	spaceContent: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	editorState: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	changesHandler: PropTypes.func,
	updateEditorState: PropTypes.func,
}

export default translate('translations')(ContentFromDb)
